import React from 'react';
import { LinkChevronSvg } from 'apps/sigma2-ui/src/components/svg/LinkChevron';
import classNames from 'classnames';
import { IconCopilotSvg } from 'apps/sigma2-ui/src/components/svg/IconCopilot';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SUPPORT_EMAIL } from 'apps/sigma2-ui/src/constants/site-meta';
import { CopilotCardStackStyle } from 'apps/sigma2-ui/src/components/focus-area/CopilotCardStackType';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { replaceTextColor } from 'apps/sigma2-ui/src/components/ui/Typography';

interface CopilotCardStackProps {
  styling: CopilotCardStackStyle;
}
export const CopilotCardStack = (props: CopilotCardStackProps) => {
  const language = useLanguage();
  const navigate = useNavigateSafe();
  const { styling } = props;

  const goToCopilotTapped = () => {
    if (styling.actionToTake.type === 'navigate') {
      navigate(styling.actionToTake.link);
    } else if (styling.actionToTake.type === 'openEmailModal') {
      const link = document.createElement('a');
      link.href = `mailto:${SUPPORT_EMAIL}`;
      link.click();
      link.remove();
      return;
    }
  };

  return (
    <div
      className={classNames(
        'relative flex-1 rounded-lg shadow-2px',
        styling.baseBackgroundColor,
      )}
    >
      <div
        className={classNames(
          'relative rounded-lg flex-1 min-h-[18rem] px-6',
          styling.baseGradientColor ?? styling.baseBackgroundColor,
        )}
      >
        <div className="flex justify-between items-start pt-6">
          <S2Typography
            variant="headline-5-alt"
            translatedContent={language[styling.title]()}
            dangerouslyOverrideClassNameFn={replaceTextColor(styling.textColor)}
          />
          <div>
            <IconCopilotSvg svg={{ className: styling.hintColor }} />
          </div>
        </div>
        <div className="flex flex-col gap-1 pt-3 w-[50%]">
          <S2Typography
            variant="headline-6-alt"
            translatedContent={language[styling.subtitle]()}
            dangerouslyOverrideClassNameFn={replaceTextColor(styling.textColor)}
          />

          <S2Typography
            variant="body-7"
            translatedContent={language[styling.description]()}
            dangerouslyOverrideClassNameFn={replaceTextColor(styling.textColor)}
          />
        </div>
        <div className="absolute bottom-4 left-6">
          <button className="flex-0" onClick={goToCopilotTapped}>
            <div
              className={classNames(
                'flex justify-start items-center',
                styling.hintColor,
              )}
            >
              <p className="text-sm font-sans font-medium">
                {language[styling.actionToTakeTitle]()}
              </p>
              <LinkChevronSvg svg={{ className: styling.hintColor }} />
            </div>
          </button>
        </div>
        <div className="absolute bottom-4 right-0 w-[50%]">
          <img className="w-[200px]" src={styling.isometricImagePath}></img>
        </div>
      </div>
    </div>
  );
};
